import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { IpConfirmActionDialogComponent } from 'src/app/invopay/components/ip-confirm-action-dialog/ip-confirm-action-dialog.component';
import FinSupplierAccountResponse from 'src/app/invopay/interfaces/fin-supplier-account-response';
import FinSupplierAccountRow from 'src/app/invopay/interfaces/fin-supplier-account-row';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { FnBlockCardModalComponent } from '../fn-block-card-modal/fn-block-card-modal.component';

@Component({
  selector: 'app-fn-providers-accounts',
  templateUrl: './fn-providers-accounts.component.html',
  styleUrls: ['./fn-providers-accounts.component.scss'],
})
export class FnProvidersAccountsComponent implements OnInit {
  @Output() changedData = new EventEmitter();
  type!: 'business' | 'employee' | 'provider';
  tableOptions!: TableOption;
  private dataChangeSubject: Subject<void> = new Subject<void>();
  dataChange: Observable<void> = this.dataChangeSubject.asObservable();
  propertyOrder: string[] = [];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private roleService: IpRoleService,
    private translateService: TranslateService,
    private ipSnackbarService: IpSnackbarService,
  ) { }

  ngOnInit(): void {
    this.type = this.roleService.getType();

    this.propertyOrder = this.setProperty();
    const statuses: Array<[string, string]> = [];
    statuses.push(['IP.TABLE.SELECT.ALL', '']);
    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: statuses,
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setProperty(): string[] {
    return [
      "businessName",
      "userName",
      "cardNumber",
      "formattedCardBalance",
      "accountNumber",
      "formattedAccountBalance",
    ];
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.SUPPLIER-ACCOUNTS';
  }

  setActions(): Array<string> {
    return ['detail', 'block'];
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  async onAction(tableEvent: TableEvent) {
    const supplierAccount: FinSupplierAccountResponse = tableEvent.dataField;
    const supplierId = supplierAccount.supplierId;
    const businessName = supplierAccount.businessName;
    switch (tableEvent.event) {
      case 'detail':
        this.router.navigate(['/invopay/admin/finance/my-finance', { supplierId, businessName }]);
        break;
      case 'block':
        const dialogRef = this.dialog.open(FnBlockCardModalComponent, {
          height: 'max-content',
          maxWidth: 'none',
          panelClass: 'custom-modal',
          data: supplierAccount,
        });
        dialogRef.afterClosed().subscribe((blocked: boolean) => {
          if (blocked) {
            this.ipSnackbarService.showSuccessMessage(
              'La tarjeta ha sido bloqueada.'
            );
            this.dataChangeSubject.next();
          }
        });
        break;
      default:
        console.warn(
          `Handler for action "${tableEvent.event}" was not defined.`
        );
        break;
    }
  }

  private async showConfirmActionDialog(
    id: string,
    action: string
  ): Promise<boolean> {
    let questionText = '';
    if (action === 'delete') {
      questionText = 'IP.CONFIRM-ACTION-DIALOG.DELETE-TEXT';
    } else if (action === 'report') {
      questionText = 'IP.CONFIRM-ACTION-DIALOG.REPORT-TEXT';
    }
    const dialogRef = this.dialog.open(IpConfirmActionDialogComponent, {
      data: {
        id,
        question: this.translateService.instant(questionText),
      },
    });
    return firstValueFrom(dialogRef.afterClosed());
  }
}

